import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { AlertComponent } from '../components/alert/alert.component';

@Injectable({ providedIn: 'root' })
export class AlertService {
    constructor(private snackBar: MatSnackBar) {}

    show(options: {
        icon?: string;
        connotation?: string;
        title: string;
        description: string;
        duration?: number;
        dismissible?: boolean;
        dismissButtonLabel?: string;
        width?: string;
    }): MatSnackBarRef<AlertComponent> {
        return this.snackBar.openFromComponent(AlertComponent, {
            data: {
                icon: options.icon ?? 'info',
                connotation: options.connotation ?? 'none',
                title: options.title,
                description: options.description,
                dismissible: options.dismissible ?? true,
                dissmissButtonLabel: options.dismissButtonLabel ?? '',
                width: options.width ?? '',
            },
            duration: options.dismissible === false ? undefined : options.duration ?? 5000,
            panelClass: ['alert-snackbar', `alert-${options.connotation ?? 'none'}`],
        });
    }
}
